<template>
  <article>
    <a :href="url" class="base-teaser">
      <div class="base-teaser__image">
        <slot />
      </div>

      <div class="base-teaser__tags">
        <div class="tag-inline-list">
          <template v-for="(item) in [...categories, ...services]">
            <TagInline
              :color="item.categoryColorHex"
              :tag="item.title"
            />
          </template>
        </div>
      </div>

      <header>
        <h3 class="base-teaser__title">
          {{ title }}
        </h3>
      </header>
      <p class="base-teaser__excerpt" v-if="excerpt">
        {{ excerpt }}
      </p>
    </a>
  </article>
</template>

<script>
import TagInline from "./TagInline.vue";

export default {
  name: "BaseTeaser",
  components: { TagInline },
  props: {
    title: {
      type: String,
      required: true,
    },

    excerpt: {
      type: String,
      required: true,
    },

    url: {
      type: String,
      required: true,
    },

    categories: {
      type: String,
      required: true,
    },

    services: {
      type: String,
      required: true,
    },
  },
  // @link https://stackoverflow.com/a/79364569/4375061
  setup(props) {
    return {
      ...props,
      categories: props.categories ? JSON.parse(props.categories) : [],
      services: props.services ? JSON.parse(props.services) : [],
    };
  },
};
</script>

<style  lang="scss">
@import "../scss/importall.scss";

.base-teaser {
  @extend %text;

  display: block;
  color: #fff;
  text-decoration: none;
}

.base-teaser__image img {
  display: block;
  width: 100%;
  height: auto;
}

.base-teaser__tags {
  margin: 1.2em 0 0.8em;
}

.base-teaser__title {
  @extend %text;
}

.base-teaser__excerpt {
  @extend %text-small;
  margin-top: -1rem;
}

.tag-inline-list {
  display: flex;
  flex-wrap: wrap;
  margin: 0 0 0 -1rem;

  > * {
    margin: 0 0 0 1rem;
  }
}
</style>
